import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} in {{waitingTime}} Minuten',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.ROOM_SERVICE]: 'Zimmer Service',
  },
};
